export const API_URL = process.env.REACT_APP_API_URL;

// Progress tracking function
const uploadFileWithProgress = (url, file, onProgress) => {
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    xhr.upload.addEventListener("progress", (event) => {
      if (event.lengthComputable) {
        const percentComplete = (event.loaded / event.total) * 100;
        onProgress(percentComplete);
      }
    });
    xhr.addEventListener("load", () => {
      if (xhr.status >= 200 && xhr.status < 300) {
        resolve();
      } else {
        reject(new Error(`Upload failed with status ${xhr.status}`));
      }
    });
    xhr.addEventListener("error", () => {
      reject(new Error("Upload error"));
    });
    xhr.open("PUT", url);
    xhr.setRequestHeader("Content-Type", file.type || "video/mp4");
    xhr.send(file);
  });
};

export const uploadVideo = async (file, onProgress) => {
  // Get a signed URL
  const urlResponse = await fetch(`${API_URL}/get-upload-url`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      filename: file.name,
      content_type: file.type || "video/mp4",
    }),
  });
  const { job_id, upload_url } = await urlResponse.json();

  // Upload the file to GCS with progress tracking
  await uploadFileWithProgress(upload_url, file, onProgress);

  // Start processing
  await fetch(`${API_URL}/start-processing`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ job_id }),
  });

  return { job_id };
};

export const getStatus = async (jobId) => {
  const response = await fetch(`${API_URL}/status/${jobId}`);
  return response.json();
};

export const downloadClip = async (jobId, filename) => {
  const response = await fetch(
    `${API_URL}/download/${jobId}?filename=${filename}`,
  );
  const blob = await response.blob();
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.click();
  window.URL.revokeObjectURL(url);
};

export const downloadAllClips = async (jobId) => {
  // Handled in ResultsPage
};
